import { ethereum } from '../configs/configPaths';
export default [ethereum];
